// RightSide.jsx
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Col, Select, Row } from "antd";
import { NavLink, useNavigate } from "react-router-dom";
import { message } from "antd";
import { sendRequestDemo } from "../../api/api";
import axiosInstance from "../../utils/axiosInstance";

const { Option } = Select;

const DemoRequestComponent = ({ date_time, onSuccess }) => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState();
  const [country, setCountry] = useState();
  const [states, setStates] = useState();
  const [form] = Form.useForm();

  const handleCountryChange = (e) => {
    const selectedCountryId = e;
    const selectedCountry = countries[selectedCountryId - 1];
    form.setFieldValue('state', undefined)
    const countryCode = selectedCountry ? selectedCountry.country_code : "";
    setCountryCode(countryCode);
    setCountry(e);
    setStates([]);
    fetchState(selectedCountryId);
  };


  const fetchState = async (value) => {
    try {
      const response = await axiosInstance.get("/state/get/", {
        customParams: {
          country_id: value,
        },
      });

      setStates(response.data);
    } catch (error) { }
  };
  const onFinish = async (values) => {
    console.log(values, 'values')
    const data = {
      ...values,
      address: {
        country: parseInt(values.country),
        state: parseInt(values.state),
      },
      date_time: date_time
    };
    delete data.country;
    delete data.state;
    try {
      setIsLoading(true);
      const { res } = await sendRequestDemo({ data });
      if (res.status === 201) {
        setIsLoading(false);
        if (onSuccess) onSuccess();
        setTimeout(() => {
          navigate("/auth/login");
        }, 2000);
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err, 'error')
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await axiosInstance.get(`/country/get/`)
        setCountries(response.data); // Update the state with the fetched user data
      } catch (error) { }
    };
    fetchCountry();
  }, []);

  return (
    <>
      <div className="">
        <h1 className="text-center text-2xl text-white font-bold mb-6">Book Demo </h1>
        <Form form={form} onFinish={onFinish} layout="vertical" className="h-[400px]">
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                name="first_name"
                label="First Name"
                rules={[{ required: true, message: "Please input your First Name!" }]}
              >
                <Input placeholder="Enter your first name" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="last_name"
                label="Last Name"
                rules={[{ required: true, message: "Please input your Last Name!" }]}
              >
                <Input placeholder="Enter your last name" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                name="email"
                label="Email Address"
                rules={[{ required: true, message: "Please input your Email!" }]}
              >
                <Input placeholder="Enter your email address" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="contact_no"
                label="Contact No"
                rules={[{ required: true, message: "Please input your Number!" }]}
              >
                <Input placeholder="Enter your contact number" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                name="entity_name"
                label="Entity Name"
                rules={[{ required: true, message: "Please input your Entity!" }]}
              >
                <Input placeholder="Enter your Entity Name" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="country"
                label="Country"
                rules={[{ required: true, message: "Please select a Country!" }]}
              >
                <Select
                  showSearch
                  placeholder="Select your country"
                  onChange={handleCountryChange}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {countries &&
                    countries.map((country) => (
                      <Option key={country.id} value={country.id}>
                        {country.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                name="state"
                label="State"
                rules={[{ required: true, message: "Please select a State!" }]}
              >
                <Select
                  showSearch
                  placeholder="Select your state"
                  disabled={!form.getFieldValue("country")}
                  optionFilterProp="children"
                  style={{backgroundColor: "#fff" , borderColor: "#d9d9d9", borderRadius: "8px"}}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {states &&
                    states.map((state) => (
                      <Option key={state.id} value={state.id}>
                        {state.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button
              type="primary"
              block
              htmlType="submit"
              loading={isLoading}
              style={{ backgroundColor: "#122253", borderColor: "#122253" }}
            >
              Submit
            </Button>
          </Form.Item>
          <div className="-mt-5">
            <p>
              Already a user?{" "}
              <NavLink to={"/auth/login/"} className="text-[#122253] font-bold">
                LOG IN
              </NavLink>
            </p>
          </div>
        </Form>
      </div>
    </>
  );
};

export default DemoRequestComponent;
